import React from 'react'
import { Button, Card, CardContent, CardHeader } from '@/shared/ui'
import type { RewardsAccountExchangeLink } from '../types'
import RewardsLinkStatusBadge from './RewardsLinkStatusBadge'
import RewardsBingxUidForm from './RewardsBingxUidForm'

export default function RewardsBingxConnectCard({
  signupUrl,
  link,
  disabled,
  onSubmitUid,
}: {
  signupUrl: string | null
  link: RewardsAccountExchangeLink | null
  disabled?: boolean
  onSubmitUid: (uid: string) => Promise<void>
}) {
  const status = link?.status || null
  const isLinked = status === 'linked'

  return (
    <Card className="border-0 shadow">
      <CardHeader className="border-b-0 text-base font-semibold">{isLinked ? 'BingX - Conta vinculada' : 'BingX - Vincular conta'}</CardHeader>
      <CardContent className="space-y-3">
        {!isLinked ? (
          <>
            <p className="text-sm text-foreground/70">
              Para participar do Rewards, crie sua conta na BingX pelo nosso link e depois vincule seu UID para confirmar que você está indicado pelo
              Cripto Alert.
            </p>

            <div className="flex flex-wrap items-center justify-between gap-3 rounded-md bg-muted/30 p-3">
              <div className="min-w-0">
                <div className="text-sm font-medium">Link de cadastro</div>
                <div className="break-words text-xs text-foreground/60">{signupUrl || 'Link não configurado pelo MASTER.'}</div>
              </div>
              <Button asChild disabled={!signupUrl}>
                <a href={signupUrl || '#'} target="_blank" rel="noreferrer">
                  Cadastrar na BingX
                </a>
              </Button>
            </div>

            {status && (
              <div className="flex items-center justify-between gap-3 rounded-md bg-muted/30 p-3">
                <div className="text-sm font-medium">Status do vínculo</div>
                <RewardsLinkStatusBadge status={status as any} />
              </div>
            )}

            {link?.last_error && <div className="rounded-md bg-amber-500/10 p-2 text-sm text-foreground">{link.last_error}</div>}

            <div className="text-sm font-medium">Já criou sua conta?</div>
            <RewardsBingxUidForm disabled={disabled} onSubmit={onSubmitUid} />
          </>
        ) : (
          <>
            <p className="text-sm text-foreground/70">
              Sua conta na BingX já está vinculada. Use as abas abaixo para acompanhar seu desconto no ciclo.
            </p>

            {link?.last_error && <div className="rounded-md bg-amber-500/10 p-2 text-sm text-foreground">{link.last_error}</div>}

            <div className="flex flex-wrap items-center justify-between gap-3 rounded-md bg-emerald-500/10 p-3 text-sm text-foreground">
              <div>Conta conectada com sucesso. Seus volumes na BingX entram automaticamente no cálculo do Rewards.</div>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  try {
                    window.location.hash = 'integracao'
                    document.getElementById('rewards-tabs')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  } catch {}
                }}
              >
                Ver detalhes
              </Button>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  )
}
